import { render, staticRenderFns } from "./StripeBalanceDetailsPage.vue?vue&type=template&id=56eb2ed6&scoped=true&"
import script from "./StripeBalanceDetailsPage.vue?vue&type=script&lang=js&"
export * from "./StripeBalanceDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./StripeBalanceDetailsPage.vue?vue&type=style&index=0&id=56eb2ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb2ed6",
  null
  
)

export default component.exports